module.exports = __webpack_public_path__ + "static/media/kredyt_22.57e65f8c.png";